import { render, staticRenderFns } from "./cfg-DadosEmpresa.vue?vue&type=template&id=6bae90e0&scoped=true&"
import script from "./cfg-DadosEmpresa.vue?vue&type=script&lang=js&"
export * from "./cfg-DadosEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./cfg-DadosEmpresa.vue?vue&type=style&index=0&id=6bae90e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae90e0",
  null
  
)

export default component.exports